export default {
    getStaff(state) {
        return state.staff;
    },
};
